import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { BenePignoratoImmobile } from '../../../models/immobili/bene-pignorato-immobile';
import { SezioneBeniImmobili } from '../../../models/sezioni/sezione-beni-immobili';
import { FormValidationService } from '../../../services/form-validation.service';
import { BeniImmobiliForm } from '../../../form/beni-immobili-form';

declare var closeModal: any;

@Component({
    selector: 'div [beni-immobili-update-form]',
  templateUrl: '../../../form/beni-immobili-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class BeniImmobiliUpdateComponent extends BeniImmobiliForm implements OnInit {
  beneImmobile: BenePignoratoImmobile;
  urlUpdate: string;
  sezione: SezioneBeniImmobili;

  @Output()
  onReturn: EventEmitter<void> = new EventEmitter<void>();


  constructor( @Inject(OperationsService) operationService: OperationsService,
               @Inject(FormBuilder) campiForm: FormBuilder,
               @Inject(HelpersService) helpers: HelpersService,
               @Inject(FormValidationService) formValidationService: FormValidationService) {
    super(operationService, campiForm, helpers, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Modifica beni immobili');
    this.isInserimento(false);
  }


  getRequest(request: BenePignoratoImmobile) {
    this.operationService.updateBeneImmobile(this.urlUpdate, this.sezione.id, request).subscribe(response => this.sezioneBeneImmobileUpdated(response));
  }

  getBeneImmobile() {
    return this.beneImmobile;
  }

  sezioneBeneImmobileUpdated(response) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(urlUpdate: string, sezione: SezioneBeniImmobili, beneImmobile: BenePignoratoImmobile) {
    this.sezione = sezione;
    this.beneImmobile = beneImmobile;
    this.populateSelect();
    this.createForm();
    this.urlUpdate = urlUpdate;
  }

  hasConvenzione(): boolean {
    return false;
  }

  hasTariffa(): boolean {
    return false;
  }

  hasDipendete(): boolean {
    return true;
  }

  hasMatricola(): boolean {
    return true;
  }

  hasAmbitiCompetenza(): boolean {
    return false;
  }
}
